<template>
  <div class="view-tasklists account-lookup-view-list">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <researcher-sidebar-menu v-if="researcher == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">New Accounts</h3>
          </div>

          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <flash-message autoHide variant="success"></flash-message>
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            >
            {{ success_message }}
          </b-alert>
          <div>
             <b-card no-body>
                <div class="row account_view_list_heading_row col-12">
                   <div
                    class="bold sno_field "
                    >
                    SI.No
                   </div>
                   <div
                     class="bold cursor-pointer account_name_field"
                     v-on:click="sortMethod('companyName')"
                     >
                     Account Name
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'companyName' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'companyName' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'companyName'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer first_name_field override-padding"
                     v-on:click="sortMethod('contact')"
                     >
                     Contact
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'contact' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'contact' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'contact'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer address_field override-padding"
                     v-on:click="sortMethod('address')"
                     >
                     Address
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'address' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'address' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'address'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer city_field  override-padding"
                     v-on:click="sortMethod('city')"
                     >
                     City
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'city' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'city' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'city'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer state_field override-padding"
                     v-on:click="sortMethod('stateCode')"
                     >
                     State
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'stateCode' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'stateCode' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'stateCode'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer zip_field override-padding"
                     v-on:click="sortMethod('zipCode')"
                     >
                     Zip Code
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'zipCode' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'zipCode' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'zipCode'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                     class="bold cursor-pointer phone_field override-padding"
                     v-on:click="sortMethod('phoneNumber')"
                     >
                     Phone
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'phoneNumber' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'phoneNumber' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'phoneNumber'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>

                   <div
                    class="bold industry_field "
                    >
                    Industry
                   </div>
                   <div
                     class="bold cursor-pointer created_field override-padding"
                     v-on:click="sortMethod('createdAt')"
                     >
                     Created
                     <span class="float-right padding-right-5 color-000">
                       <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                       <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       <i v-if="sortField != 'createdAt'" class="fa fa-sort" aria-hidden="true"></i>
                     </span>
                   </div>
                   <div
                    class="bold affiliate_field "
                    >
                    Approve
                   </div>
                   <div
                    class="bold delete_field "
                    >
                    Delete
                   </div>


                 </div>

                 <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

                 <b-card-text v-if="account_lists.length > 0">
                    <div class="view-accountlist">
                      <div v-for="(account_list, index) in account_lists" class="tasklist-row">
                        <div class="row tasklist-item col-12">
                          <div class="sno_field row_field">{{ sno + index + 1 }}</div>
                          <div class=" row_field cursor-pointer account_name_field" v-on:click="router_redirect(account_list.accId)"
                            >
                            {{ account_list.accountName }}
                          </div>
                          <div class="first_name_field row_field">{{ account_list.name }}</div>
                          <div class="address_field row_field">{{ account_list.address }}</div>
                          <div class="city_field row_field">{{ account_list.city }}</div>
                          <div class="state_field row_field">{{ account_list.state }}</div>
                          <div class="zip_field row_field">{{ account_list.zip }}</div>
                          <div class="phone_field row_field" >{{ account_list.phone }}</div>
                          <div class="industry_field row_field" >{{ account_list.industries_type }}</div>
                          <div class="created_field row_field" >{{ account_list.createdAt }}</div>
                          <div class="affiliate_field row_field" >
                            <button
                              v-on:click="openAssignModal(account_list), verrors.clear()"
                              class="btn btn-red btn-md input-height-15" style="margin-top: 7px; width: 67px; padding: 5px 5px;"
                              >Approve</button>
                          </div>
                          <div class="delete_field row_field" style="text-align: center;">
                            <div class="search-padd delete-icon" @click="deleteAccountConfirm(account_list)"><i  aria-hidden="true" class="fa fa-window-close cursor-pointer"></i></div>
                          </div>
                        </div>
                        <div><hr></div>
                      </div>
                    </div>
                    <div class="col-12 float-left override-padding pagination-wrapper">
                     <Pagination
                     ref="Pagination"
                     :currentPage="currentPage"
                     :totalRows="rows"
                     :perPage="perPage"
                     :showPaginatedFunction="showNaicsofPaginated"
                     :showPerPageFunction="perPagePaginated"
                     :totalPages="totalPages"
                     :sNo="sno"
                     >
                     </Pagination>
                    </div>
                 </b-card-text>
                 <b-card-text v-else-if="loading == false">
                      No accounts found.
                 </b-card-text>
             </b-card>
           </div>
         </div>
       </div>
     </div>


    <DeleteAccountsModal :isModalVisible="isDeleteAccountModalVisible"  @close="isDeleteAccountModalVisible = false, delete_confirm_msg=''">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading assign-heading"><h3>Delete Account</h3></div>
      <div slot="body" class="send-assessment-content" v-if="isDeleteAccountModalVisible == true">
        <div class="col-12 p-0">

          <div class="col-12 p-0 assign-modal-heading" style="margin-bottom: 10px;">
            Are you sure you want to delete {{ accountItems.accountName }}? <span style="font-weight: normal;">Deleted accounts will be removed from the system.</span>
          </div>
          <div class="col-12 p-0">
            <input v-model="delete_confirm_msg"
                  name="delete_confirm_msg"
                  placeholder="Type 'yes' to delete account"
                  @keyup="checkMessageValid"
                  @blur="checkMessageValid"
                  class="col-12 input-height-25"
                  v-validate="'required'"
                  maxlength="3" />
            <div v-if="verrors.firstByRule('delete_confirm_msg', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-top: 0px;">Enter confirmation message</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 p-0 assign-modal-heading" style="margin-bottom: 5px;">
            Are you sure you want to notify the user?
          </div>
          <div class="col-12 p-0">
            <div class="col-lg-2 float-left col-12 override-padding" v-for="(option, index) in notify_options">
              <input :value="option.value" type="radio" v-on:change="notifyOptions()" name="notify_option" v-model="notify_value">
              <label>{{ option.text }}</label>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="col-12 p-0 assign-modal-heading" style="margin-bottom: 5px;" v-if="notify_message_display == true">
            Select notification template
          </div>
          <div class="col-12 p-0" v-if="notify_message_display == true">
              <b-form-select
                class="input-text"
                name="notification_template"
                v-model="selected_notify_template"
                :options="template_options"
                v-validate="'required'">
              </b-form-select>          
            <div style="clear: both;" class="margin-bottom-10"></div>
          </div>
          <div class="col-12 p-0" style="margin-top: 20px;">
            <div class="col-6 p-0 float-left" style="text-align: left;">
              <button
                  @click="isDeleteAccountModalVisible=false,delete_confirm_msg=''"
                  class="btn btn-white col-4 input-height-25 createBtn" style="border-radius: 10px;"
                  ><b>Cancel</b></button>
            </div>
            <div class="col-6 p-0 float-right" style="text-align: right;">
              <button
                  v-on:click="deleteAccount()"
                  class="btn btn-red col-8 input-height-25 createBtn" style="border-radius: 10px;" :disabled="delete_button_disable"
                  ><b>Delete Account</b></button>
            </div>
            <div style="clear: both;"></div>
          </div>


        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">
      </div>
    </DeleteAccountsModal>


    <AffiliateAssignModal :isModalVisible="isModalVisible" @close="isModalVisible = false,affiliate=[]">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading assign-heading"><h3>Approve Account</h3></div>
      <div slot="body"  v-if="isModalVisible == true">
        <div class="col-11 p-0">
          <div class="col-12 p-0 assign-modal-heading">
            Select the Affiliate for the account below - 
          </div>
          <div class="col-12 p-0 assign-modal-heading">
            Account Name - <span style="font-weight: normal;">{{ accountItems.accountName }}</span>
          </div>
          <div class="col-12 p-0 assign-modal-heading">
            Contact - <span style="font-weight: normal;">{{ accountItems.name }}</span>
          </div>
          <div class="col-12 p-0 assign-modal-heading">
            Address - <span style="font-weight: normal;">{{ accountItems.address }}</span>
          </div>
          <div class="col-12 p-0">
            <div class="col-6 p-0 float-left">
              <div class="col-12 p-0 assign-modal-heading">
                City - <span style="font-weight: normal;">{{ accountItems.city }}</span>
              </div>
              <div class="col-12 p-0 assign-modal-heading">
                State - <span style="font-weight: normal;">{{ accountItems.state }}</span>
              </div>
              <div class="col-12 p-0 assign-modal-heading">
                Zip Code - <span style="font-weight: normal;">{{ accountItems.zip }}</span>
              </div>
            </div>
            <div class="col-6 p-0 float-left">
              <div class="col-12 p-0 assign-modal-heading">
                Industry - <span style="font-weight: normal;">{{ accountItems.industries_type }}</span>
              </div>
              <div class="col-12 p-0 assign-modal-heading">
                Program - <span style="font-weight: normal;">{{ accountItems.program }}</span>
              </div>
              <div class="col-12 p-0 assign-modal-heading">
                Account Type - <span style="font-weight: normal;">{{ accountItems.schoolFlag }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div class="col-11 override-padding" style="display:block;">
          <div 
            class="search-padd" 
            id="affliate-wrapper" 
            style="height: 30px;width: 95%;">
            <multiselect v-model="affiliate"
              :options="affiliate_options"
              track-by="value"
              label="text"
              placeholder="Select Affiliate"
              :multiple="true"
              :close-on-select="false"
              :show-labels="false"
              v-bind:name="'affiliate[]'"
              v-bind:id="'affiliate'"
              @input="onSelect"
              v-validate="'required'">
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
            </multiselect>
          </div>

        </div>
        <div v-if="verrors.firstByRule('affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div class="col-12 p-0" style="margin-top: 50px;">
          <div class="col-6 p-0 float-left" style="text-align: left;">
            <button
                @click="isModalVisible=false,affiliate=[]"
                class="btn btn-white col-4 input-height-25 createBtn" style="border-radius: 10px;"
                ><b>Cancel</b></button>
          </div>
          <div class="col-6 p-0 float-right" style="text-align: right;">
            <button
                :disabled="approve_button_disable"
                v-on:click="assignAffiliateAction()"
                class="btn btn-red col-8 input-height-25 createBtn" style="border-radius: 10px;"
                ><b>Approve Account</b></button>
          </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </AffiliateAssignModal>






  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import Pagination from '../pagination.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import ResearcherSidebarMenu from '../shared/researcher_sidebar_menu.vue';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';
import DeleteAccountsModal from '../admin/customer_account_delete_modal.vue';
import AffiliateAssignModal from '../admin/assign_account_affiliate_modal.vue';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {

        data() {
          return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            account_lists: [],
            loading: false,
            sortField: '',
            sortBy: '',
            searchParameters: {

            },
            sno: 0,
            pageOptions: [],
            totalPages: 0,
            researcher: false,
            masterAdmin: false,
            csr: false,
            isDeleteAccountModalVisible: false,
            account_id: '',
            success_message: '',
            dismissCountDown: 0,
            affiliate_options: [],
            affiliate: [],
            isModalVisible: false,
            accountItems: [],
            delete_button_disable: true,
            approve_button_disable: true,
            delete_confirm_msg: '',
            notify_options: [
              { value: 'Yes', text: 'Yes' },
              { value: 'No', text: 'No' }
            ],
            notify_value: 'No',
            notify_message: 'Hello {firstName} {lastName},\n\nYour account {companyName} has been deleted because of following reason:\n\n',
            notify_message_display: false,
            selected_notify_template: '',
            template_options: [],
          }
        },

        components: {
          UserMenu,
          GoBack,
          Pagination,
          MasteradminSidebarMenu,
          ResearcherSidebarMenu,
          CSRSidebarMenu,
          DeleteAccountsModal,
          AffiliateAssignModal,
          Multiselect,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            notifyOptions: function() {
              if(this.notify_value == 'Yes') {
                this.notify_message_display = true;
              }
              else {
                this.notify_message_display = false;
              }
            },
            onSelect: function() {
              if(this.affiliate.length > 0) {
                this.approve_button_disable = false;
              }
              else {
                this.approve_button_disable = true;
              }
            },
            router_redirect: function(accountId) {
                this.flash({ message: "Account is awaiting approval from business.", variant: 'warning' });
                let routeData = this.$router.resolve({name: 'accountlookupdetail', params: {account_id: accountId}});
                window.open(routeData.href, '_blank');
              
            },
            checkMessageValid() {
              if(this.delete_confirm_msg == 'yes') {
                this.delete_button_disable = false;
              }
              else {
                this.delete_button_disable = true;
              }
            },
            openAssignModal: function(item) {
              this.errors = '';
              this.verrors.clear();
              this.isModalVisible = true;
              this.accountItems = item;
            },
            countDownChanged(dismissCountDown) {
              this.dismissCountDown = dismissCountDown
            },
            assignAffiliateAction: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  axios('/assign-affiliate-accounts/' + this.accountItems.accId,
                     {
                       method: 'POST',
                       data:
                        {
                          affiliate_selected: this.affiliate,
                        },
                     }
                   )
                  .then((resp) => {
                      this.isModalVisible = false;
                      this.affiliate = [];
                      this.fetchAccountList();
                      this.success_message = 'Affiliate assigned to account successfully.';
                      this.dismissCountDown = 5;    
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });
                  
                }
              })
              .catch(() => {

              });

            },
            fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

            },
            deleteAccountConfirm: function(item) {
              this.errors = '';
              this.verrors.clear();
              this.isDeleteAccountModalVisible = true;
              this.accountItems = item;
            },
            doValidate: function() {
              var flag = 1;
              if(this.notify_value == 'Yes') {
                if(this.selected_notify_template == '') {
                  alert("Please select notification template");
                  flag = 0;
                  return false;
                }
              }

              return flag;
            },
            deleteAccount: function() {
              var flag = this.doValidate();
              if(flag == 1) {
              this.isDeleteAccountModalVisible = false;
              this.showOverlay = true;              
              axios('/account-lookup/customer-accounts/' + this.accountItems.accId,
                 {
                   data:
                    {
                      selected_notify_template: this.selected_notify_template,
                      notify_value: this.notify_value,
                    },
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchAccountList();
                  this.success_message = 'Account deleted successfully.';
                  this.dismissCountDown = 5;

                  this.notify_value = 'No';
                  this.notify_message_display = false;
                  this.selected_notify_template = '';
                  this.delete_confirm_msg = '';
                  this.delete_button_disable = true;    
               })
              .catch(error => {

              });
              }
            },
            sortMethod: function(field) {
              this.sortField = field;
              if(this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
              }
              else {
                this.sortBy = 'ASC';
              }
              this.fetchAccountList();
            },
            showNaicsofPaginated() {
              this.currentPage = this.$refs.Pagination.currentPageValue;
              this.fetchAccountList();
            },
            perPagePaginated() {
              this.currentPage = 1;
              this.$refs.Pagination.currentPageValue = 1;
              this.perPage = this.$refs.Pagination.perPageValue;
              this.fetchAccountList();
            },
            fetchAccountList: function() {
              this.loading = true;
              var searchParam = {};
              searchParam.page = this.currentPage;
              searchParam.perPage = this.perPage;
              if(this.sortField) {
                searchParam.sortField = this.sortField;
                searchParam.sortBy = this.sortBy;
              }

              axios("/account-lookup/customer-account-lists", {
                method: 'POST',
                data: {
                  search_parameters: searchParam,
                }
              })
              .then(response => {
                this.loading = false;
                this.account_lists = response.data.data;
                this.currentPage = response.data.page;
                if(this.currentPage > 1) {
                  this.sno = this.perPage * (this.currentPage - 1);
                }
                else {
                  this.sno = 0;
                }
                this.rows = response.data.total_rows;
                this.totalPages = response.data.total_pages;
                
              })
              .catch(error => {

              });
            },
        },
        mounted() {

        },
        created() {
          document.body.className = 'naicslist-page';
          this.fetchAccountList();
          this.fetchAffiliateOptions();
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_RESEARCHER') > -1) {
            this.researcher = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }

          axios.get('/delete-account-notification-template', {

             })
             .then((response) => {
                 var template_option = { value: '', text: 'Select Template' };
                 this.template_options.push(template_option);
                 for(var i=0; i < response.data.length; i++) {
                   template_option = {value: response.data[i].id, text: response.data[i].templateName};
                   this.template_options.push(template_option);
                 }
             })
             .catch(error => {

          });
        },
    }
</script>

<style scoped>
@import '../../assets/styles/account_lookup.css';

.view-accountlist {
  min-height: 70vh;
}
.view-accountlist .tasklist-row:last-child{
  border-bottom: 1px solid #E5E5E5;
}

.account_view_list_heading_row {
    /* background-color: #dc2227; */
    background-color: #00ACEE;
    line-height: 25px;
    color: #FFF;
    padding: 3px 0px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
.industry_field {
  width: 11%;
  border-right: 1px solid #b6b6b6;
  padding-left: 5px;
}
.sno_field {
  width: 4%;  
}
.account_name_field {
  width: 11%;
}
.created_field {
  width: 7%;
  border-right: 1px solid #b6b6b6;
  padding-left: 5px;
}
.affiliate_field {
  width: 8%;
  border-right: 1px solid #b6b6b6;
  padding-left: 5px;
}
.delete_field {
  width: 6%;
  border-right: 0px solid #b6b6b6;
  padding-left: 5px;
}
.phone_field {
  width: 7%;
  border-right: 1px solid #b6b6b6;
}
.assign-modal-heading {
  font-weight: bold;
  font-size: 13px;
  color: #082E40;
  padding-bottom: 5px !important;
}
.assign-heading  h3{
  font-size: 13px !important;
  font-weight: bold;
  color: #082E40 !important;
  padding-bottom: 0px;
}
.assign-heading {
  padding-bottom: 0px;
  margin-bottom: 0px; 
}
.send-assessment-content input, .send-assessment-content textarea {
  border: 1px solid #CCC;
  border-radius: 5px;
  resize: none;
}

</style>
<style>
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/customer_accounts_view_list.vue